import { ResourceCard } from './resource-card';
import type { CardProps } from './types';

/** Upload block tile — no banner field, so it always shows the resource icon. */
export const GcsUploadCard = ({ block, onClick }: CardProps) => (
  <ResourceCard block={block} onClick={onClick} caption={block.title || 'Upload'} />
);
